import {config} from '@config';
import anime from 'animejs';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {sharedComponent} from '@lib/utils';
import {createApplicationState} from '@services/ApplicationState';
import {IApplicationState} from '@services/types';

@sharedComponent
export class PageIndicator extends ConnectedComponent<HTMLDivElement> {
  private appState: IApplicationState = createApplicationState();
  private logo: HTMLElement | undefined | null;

  didMount() {
    // if (this.element) {
    //   this.element.style.display = 'none';
    //   return;
    // }
    this.logo = this.element?.querySelector('.o-page-indicator_logo');

    // anime({
    //   delay: 100,
    //   duration: 700,
    //   easing: 'easeInOutCubic',
    //   opacity: 1,
    //   targets: this.logo,
    // });

    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'startShowAnimation') {
        // anime({
        //   duration: 300,
        //   easing: 'easeOutCubic',
        //   opacity: 1,
        //   targets: this.logo,
        // });
      }
      if (status === 'show') {
        if (this.element) {
          this.element.style.display = 'block';
          this.appState.updatePageIndicatorStatus('startShowAnimation');
        }
        anime({
          complete: () => {
            this.appState.updatePageIndicatorStatus('endShowAnimation');
          },
          duration: config.pageIndicatorShowAnimationDuration,
          easing: 'easeOutQuart',
          opacity: 1,
          targets: this.element,
        });
      } else if (status === 'hide') {
        this.appState.updatePageIndicatorStatus('startHideAnimation');
        anime({
          complete: () => {
            if (this.element) {
              this.element.style.display = 'none';
              this.appState.updatePageIndicatorStatus('endHideAnimation');
            }
          },
          duration: config.pageIndicatorHideAnimationDuration,
          easing: 'easeInOutCubic',
          opacity: 0,
          targets: this.element,
        });

        // anime({
        //   duration: config.pageIndicatorHideAnimationDuration - 100,
        //   easing: 'easeOutCubic',
        //   opacity: 0,
        //   targets: this.logo,
        // });
      }
    });
  }
}
